import React, { useRef } from 'react';

import useDropdown from '@/hooks/shared/useDropdown';

import { IconEllipsisVertical } from '@/components/apps/ui/icon';

import ButtonIcon from '../buttons/ButtonIcon';
import DropDown, { Props as DropDownProps } from './DropDown';

/**
 * dropdownIcon: 드롭다운 버튼으로 사용할 아이콘
 * defaultMenuIsOpen: 드롭다운 메뉴의 초기 열림 상태
 */
type Props = {
  dropdownIcon?: React.ReactNode;
  defaultMenuIsOpen?: boolean;
  dropdownIconDisabled?: boolean;
} & DropDownProps;

const SizeWidthStyle = {
  sm: 'auto',
  md: '280px',
};

export default function DropDownWithButton({
  items,
  size = 'sm',
  dropdownIcon = <IconEllipsisVertical size={16} />,
  defaultMenuIsOpen = false,
  styleWidthSize = SizeWidthStyle[size],
  dropdownIconDisabled = false,
  align = 'left',
}: Props) {
  const targetRef = useRef(null);
  const [isOpen, setIsOpen] = useDropdown(targetRef, defaultMenuIsOpen);

  const handleToggle = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div className="relative flex w-fit">
      <span ref={targetRef}>
        <ButtonIcon
          type="button"
          disabled={dropdownIconDisabled}
          onClick={handleToggle}
        >
          {dropdownIcon}
        </ButtonIcon>
      </span>
      {isOpen && (
        <DropDown
          items={items}
          size={size}
          styleWidthSize={styleWidthSize}
          align={align}
        />
      )}
    </div>
  );
}
